"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const botones_1 = require("../../botones");
class GridColumnButtons extends React.PureComponent {
    render() {
        const props = this.props;
        return (React.createElement("span", { style: { opacity: this.props.showButtons ? 1 : 0.2 } },
            props.orden &&
                React.createElement(botones_1.Link, { onClick: props.onOrdenar, style: "info", iconClass: "fa fa-sort-" + props.orden }),
            React.createElement(botones_1.Link, { style: props.estaFiltrado ? "info" : undefined, iconClass: "fa fa-filter", onClick: props.onFiltrar }),
            props.onQuitar && (props.puedeQuitarOriginal || props.esDrillDown) &&
                React.createElement(botones_1.Link, { style: "danger", iconClass: "fa fa-times", onClick: props.onQuitar })));
    }
}
const thStyle = { whiteSpace: "nowrap", cursor: "pointer" };
class GridColumnComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { visible: false };
    }
    render() {
        const props = this.props;
        return (React.createElement("th", { style: thStyle, onMouseEnter: () => this.setState({ visible: true }), onMouseLeave: () => this.setState({ visible: false }) },
            React.createElement("span", null,
                React.createElement("span", { onClick: this.props.puedeOrdenar ? this.props.onOrdenar : undefined }, this.props.titulo),
                React.createElement(GridColumnButtons, Object.assign({}, this.props, { showButtons: this.state.visible })))));
    }
}
exports.GridColumnComponent = GridColumnComponent;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/column.js
// module id = 2218
// module chunks = 0